import { ICompareInChart } from "@/api";

export const comparisonHasFields = (comparison: ICompareInChart) => {
    return comparison.scopes.some(
        (scope) => scope.extracted_fields_v2.length > 0
    );
};
